define('home/views/DiscussionCoverActionsView',[
    'home/views/ThreadCardDefaultFooterView',

    'home/templates/discussionCoverActions',
], function (
    ThreadCardDefaultFooterView,

    discussionCoverActionsTemplate
) {
    'use strict';

    var parent = ThreadCardDefaultFooterView;
    var parentProto = parent.prototype;

    var DiscussionCoverActionsView = parent.extend({
        template: discussionCoverActionsTemplate,

        toggleThreadFavorited: function (evt) {
            parentProto.toggleThreadFavorited.call(this, evt);
            this.$('[data-action=favorite]').addClass('animate-recommend');
        },
    });

    return DiscussionCoverActionsView;
});

